import {SCHEMA_TYPES} from "../schemas/definitions";
import SchemaFieldList from "./SchemaFieldList";

/**
 * Form động sinh từ định nghĩa schema (definitions.js). Presentational/controlled:
 * giá trị `values` + `onChange(values)` do trang Generator sở hữu (để cập nhật
 * preview JSON-LD trực tiếp).
 */
function DynamicSchemaForm({type, values, onChange}) {
	const def = SCHEMA_TYPES[type];

	if (!def) return null;

	return <SchemaFieldList fields={def.fields} values={values || {}} onChange={onChange} />;
}

export default DynamicSchemaForm;
